import React from "react";
import { AddDealerContextProvider } from "./AddDealerView";
import AddDealer from "./views/AddDealer";

const AddDealerPage = () => {
  return (
    <AddDealerContextProvider>
      <AddDealer />
    </AddDealerContextProvider>
  );
};

export default AddDealerPage;
